import { render, staticRenderFns } from "./ComGoodsDoc.vue?vue&type=template&id=d4ba6b88&scoped=true&"
import script from "./ComGoodsDoc.vue?vue&type=script&lang=js&"
export * from "./ComGoodsDoc.vue?vue&type=script&lang=js&"
import style0 from "./ComGoodsDoc.vue?vue&type=style&index=0&id=d4ba6b88&prod&lang=css&"
import style1 from "./ComGoodsDoc.vue?vue&type=style&index=1&id=d4ba6b88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ba6b88",
  null
  
)

export default component.exports